"use client";
import { motion } from "framer-motion";

// All positions are deterministic to prevent SSR/CSR hydration mismatches.
// There is only one HeroBackground per page so constant ids are safe.

const SPARKLE_STARS = [
  // Near top edge (inside secondary glow band)
  { id: 1, x: 7, y: 4, size: 5, delay: 0 },
  // { id: 2, x: 22, y: 2, size: 3.5, delay: 1.3 },
  // { id: 3, x: 41, y: 6, size: 6, delay: 0.6 },
  // { id: 4, x: 63, y: 3, size: 4, delay: 2.1 },
  // { id: 5, x: 81, y: 7, size: 5.5, delay: 0.9 },
  { id: 6, x: 95, y: 2, size: 3.5, delay: 1.7 },
  // Near bottom edge (inside secondary glow band)
  { id: 7, x: 11, y: 93, size: 4.5, delay: 1.0 },
  // { id: 8, x: 33, y: 96, size: 5.5, delay: 2.4 },
  // { id: 9, x: 52, y: 91, size: 3.5, delay: 0.4 },
  // { id: 10, x: 73, y: 95, size: 5, delay: 1.8 },
  { id: 11, x: 89, y: 92, size: 4, delay: 0.7 },
  // Midfield scatter
  { id: 12, x: 16, y: 45, size: 3, delay: 2.9 },
  // { id: 13, x: 38, y: 55, size: 2.5, delay: 1.4 },
  // { id: 14, x: 62, y: 42, size: 3, delay: 3.3 },
  { id: 15, x: 79, y: 62, size: 2.5, delay: 1.1 },
];

const FLOAT_PARTICLES = [
  { id: 1, x: 12, size: 3.5, duration: 9, delay: 0 },
  { id: 2, x: 29, size: 2.5, duration: 11, delay: 2.5 },
  // { id: 3, x: 47, size: 4.5, duration: 8, delay: 5 },
  // { id: 4, x: 66, size: 3, duration: 12, delay: 1.5 },
  // { id: 5, x: 83, size: 3.5, duration: 10, delay: 3.5 },
  // { id: 6, x: 55, size: 2.5, duration: 13, delay: 7 },
];

// 4-pointed star shape via clip-path
const STAR_PATH =
  "polygon(50% 0%, 56% 44%, 100% 50%, 56% 56%, 50% 100%, 44% 56%, 0% 50%, 44% 44%)";

export default function HeroBackground() {
  return (
    <motion.div
      aria-hidden
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
      style={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        zIndex: 0,
        pointerEvents: "none",
      }}
    >
      {/* Floating star particles — drift upward, fade into the top glow */}
      {FLOAT_PARTICLES.map((p) => (
        <motion.div
          key={p.id}
          style={{
            position: "absolute",
            left: `${p.x}%`,
            bottom: -8,
            width: p.size,
            height: p.size,
            clipPath: STAR_PATH,
            background: "white",
          }}
          animate={{ y: [0, -1700], opacity: [0, 0, 0.8, 0.8, 0] }}
          transition={{
            duration: p.duration,
            repeat: Infinity,
            repeatDelay: p.delay,
            delay: p.delay,
            ease: "easeIn",
            times: [0, 0.1, 0.28, 0.82, 1],
          }}
        />
      ))}

      {/* Twinkling sparkle stars — concentrated near secondary edge bands */}
      {SPARKLE_STARS.map((s) => (
        <motion.div
          key={s.id}
          animate={{ opacity: [0, 1, 0.45, 1, 0], scale: [0.4, 1, 0.7, 1, 0.4] }}
          transition={{
            duration: 2.6 + (s.id % 4) * 0.65,
            delay: s.delay,
            repeat: Infinity,
            repeatDelay: 1.4 + (s.id % 3) * 0.9,
            ease: "easeInOut",
          }}
          style={{
            position: "absolute",
            left: `${s.x}%`,
            top: `${s.y}%`,
            x: "-50%",
            y: "-50%",
            width: s.size * 6,
            height: s.size * 6,
          }}
        >
          {/* 4-pointed star centre */}
          <div
            style={{
              position: "absolute",
              inset: "38%",
              clipPath: STAR_PATH,
              background: "white",
            }}
          />
        </motion.div>
      ))}
    </motion.div>
  );
}
